import { fetchQueryApi, postApi } from 'api/fetchApi'
import { NodeHeaders } from 'api/NodeHeaders'
import { ProfileStatus } from 'api/profile/profile.functions'
import { Cursor } from 'api/search/search.types'

import { paths } from './generated/search'

const parseCursor = (cursorObject: Cursor) => {
  if (cursorObject) {
    return Object.keys(cursorObject).reduce((result, key) => {
      result[`cursor[${key}]`] = cursorObject[key]
      return result
    }, {})
  }
}

export const resetSearchSettingsApi = () => postApi('/search/normalizeOptions')

type SearchPath = paths['/search']
type SearchMethod = SearchPath['get']
type SearchQuery = SearchMethod['parameters']['query']
type SearchResponse = SearchMethod['responses']['200']['schema']

export const simpleSearchApi = (
  limit: number,
  cursor: Cursor,
  headers?: NodeHeaders
) => {
  const parsedCursor = parseCursor(cursor)

  return fetchQueryApi<SearchResponse, SearchQuery>(
    '/search',
    {
      statusNames: [
        ProfileStatus.VerifiedPhoto,
        ProfileStatus.SpaceTimeLocation,
        ProfileStatus.Online,
      ].join(','),
      limit,
      ...parsedCursor,
    },
    { headers }
  )
}
